/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type UpdateResourceMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  isSaas?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  isVisible?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateResourceMutation = { __typename: 'Mutation', updateResource?: { __typename: 'UpdateResourceMutation', success?: boolean | null, errors?: Array<string | null> | null, resource?: { __typename: 'ResourceType', id: string, isSaas: boolean, isVisible: boolean } | null } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const UpdateResourceDocument = new TypedDocumentString(`
    mutation UpdateResource($id: ID!, $isSaas: Boolean, $isVisible: Boolean) {
  updateResource(id: $id, isSaas: $isSaas, isVisible: $isVisible) {
    success
    errors
    resource {
      id
      isSaas
      isVisible
    }
  }
}
    `);

export const useUpdateResourceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateResourceMutation, TError, UpdateResourceMutationVariables, TContext>) => {
    
    return useMutation<UpdateResourceMutation, TError, UpdateResourceMutationVariables, TContext>(
      {
    mutationKey: ['UpdateResource'],
    mutationFn: (variables?: UpdateResourceMutationVariables) => fetcher<UpdateResourceMutation, UpdateResourceMutationVariables>(UpdateResourceDocument, variables)(),
    ...options
  }
    )};


useUpdateResourceMutation.fetcher = (variables: UpdateResourceMutationVariables) => fetcher<UpdateResourceMutation, UpdateResourceMutationVariables>(UpdateResourceDocument, variables);
